import styled, { css } from 'styled-components';
import { LinkStyledProps } from './Link.types';
import { get } from 'lodash';

const Link = styled.a<LinkStyledProps>`
  color: ${(props) =>
    get(props.theme.brand, props.$color) || props.theme.brand.primary.base};

  ${({ $disabled }) =>
    $disabled &&
    css`
      cursor: not-allowed;
      color: #999;
    `}
`;

export { Link };
